import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {Worker} from 'src/app/workers/shared/model/worker.model';

@Injectable()
export class WorkerResolver implements Resolve<Observable<Worker>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Worker> {
    const workerId = route.queryParams['w'];
    return this.facadeService.getWorkerById(+workerId).pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
